import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import DatePicker from "react-datepicker";
import moment from "moment";
import { toast } from "react-toastify";
import { CloudDownload, NotebookTabs } from "lucide-react";
import { StylesDatePicker } from "../../../ui/stylesDatePicker";
import { ModalButton } from "../../../ui/buttons";
import { ContentKpi, IconKpi, KPIcard } from "../../../ui/kpis";
import { CustomLabel } from "../../../ui/labels";
import { configDatePickerLenguage } from "../../../components/RelevosInfoGeneral/utils";
import useFetcher from "../../../hooks/useFetcher";
import { BlurSpinner } from "../../../components/BlurSpinner";
import { humanDateFormat } from "../../../../config/constants";
import { exportPlaybook, KpisPlaybook } from "../../../services/playbookServices";

const PlaybookModalKPI = ({ toggle, isOpen }) => {
  const unMesAtras = moment().subtract(30, "days").format("DD/MM/YYYY");
  const fechaActual = moment().format("DD/MM/YYYY");
  const locale = configDatePickerLenguage();
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [params, setParams] = useState([{ startDate: moment().subtract(30, "days").format("YYYY-MM-DD"), endDate: moment().format("YYYY-MM-DD") }]);
  const [kpis, isLoadingKpis] = useFetcher(KpisPlaybook, params);
  const [exportingPlaybook, setExportingPlaybook] = useState(false);

  // funcion para exportar
  const handleExportar = async () => {
    if (startDate && endDate) {
      setExportingPlaybook(true);
      try {
        toast.success("Su solicitud de exportación está siendo procesada...");
        const blob = await exportPlaybook(params[0]);
        const link = document.createElement("a");
        const url = window.URL.createObjectURL(blob);
        const filename = `Playbook-${moment().format(humanDateFormat)}.csv`;
        link.href = url;
        link.setAttribute("download", filename);
        link.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        toast.error(`Error al exportar el archivo`);
      }

      setExportingPlaybook(false);
    }
    toggle();
  };

  // actualiza el rango de fechas con los ultimos 30 dias
  useEffect(() => {
    setDateRange([moment(unMesAtras, "DD/MM/YYYY").toDate(), moment(fechaActual, "DD/MM/YYYY").toDate()]);
  }, []);

  // formatea la fecha para los params
  useEffect(() => {
    if (startDate && endDate) {
      const start = moment(startDate).format("YYYY-MM-DD");
      const end = moment(endDate).format("YYYY-MM-DD");
      setParams([{ startDate: start, endDate: end }]);
    }
  }, [startDate, endDate]);

  // formatea el valor del rango de fechas
  const getDataRangeValue = (inputStartDate, inputEndDate) => {
    const start = inputStartDate ? moment(inputStartDate).format("DD/MM/YYYY") : "";
    const end = inputEndDate ? moment(inputEndDate).format("DD/MM/YYYY") : "";
    return `${start} - ${end}`;
  };

  return (
    <div style={{ fontFamily: "Nunito" }}>
      <Modal isOpen={isOpen} centered style={{ maxWidth: "450px", width: "50%" }}>
        <ModalHeader className="border-0 height-50" toggle={toggle} style={{ backgroundColor: "#f8f8f8", borderRadius: "8px" }} />
        <ModalBody style={{ backgroundColor: "#f8f8f8", borderRadius: "8px" }}>
          <>
            <CloudDownload size={50} />
            <div className="col-md-12">
              <StylesDatePicker className="mb-3 w-100">
                <CustomLabel htmlFor="fechaTC"> Rango de fechas de Playbook </CustomLabel>
                <DatePicker
                  locale={locale}
                  id="fecha"
                  className="digits date-input"
                  selectsRange
                  startDate={startDate}
                  endDate={endDate}
                  onChange={(update) => {
                    setDateRange(update);
                  }}
                  value={getDataRangeValue(startDate, endDate)}
                />
              </StylesDatePicker>
            </div>
            <div className="col-md-10">
              <BlurSpinner isLoading={isLoadingKpis}>
                <KPIcard className="card">
                  <div className="card-body d-flex align-items-center justify-content-start mb-2 mx-10 pb-0">
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <IconKpi>
                        <NotebookTabs size={50} />
                      </IconKpi>
                      <ContentKpi>
                        <h3>Registro Playbook</h3>
                        <div className="d-flex align-items-end justify-content-start">
                          {kpis ? (
                            <>
                              <p>{kpis}</p>
                            </>
                          ) : (
                            <p>-</p>
                          )}
                        </div>
                      </ContentKpi>
                    </div>
                  </div>
                </KPIcard>
              </BlurSpinner>
            </div>
          </>
          <ModalFooter className="border-0 w-100">
            <div className="d-flex justify-content-end">
              <ModalButton className="btn px-2 py-1 text-center mr-2" onClick={toggle} type="button">
                Cerrar
              </ModalButton>
              <ModalButton
                className="btn px-2 py-1 text-center"
                style={{ backgroundColor: "#F0292A", color: "white" }}
                onClick={() => {
                  handleExportar();
                }}
                type="button"
                disabled={exportingPlaybook}
              >
                Exportar
              </ModalButton>
            </div>
          </ModalFooter>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default PlaybookModalKPI;
